import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import { pruneStaleApiCache } from "utils/offlineDb";
import env from "variables/config";

Sentry.init({
    dsn: "https://afc88a9eec8e9bf83e4ebf37fe7fe0ec@o4509826662662144.ingest.de.sentry.io/4509887200559184",
    integrations: [
        new Sentry.BrowserTracing(),
        new Sentry.Replay({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// ─── Service Worker registration ──────────────────────────────────────────────
if ('serviceWorker' in navigator) {
    const apiBaseUrl = env.apiUrl || process.env.REACT_APP_API_URL;

    const postApiBaseUrlToSw = (registration: ServiceWorkerRegistration | null) => {
        if (!apiBaseUrl || !registration) return;

        const targetWorker = registration.active || registration.waiting || registration.installing;
        if (targetWorker) {
            targetWorker.postMessage({
                type: 'SET_API_BASE_URL',
                url: apiBaseUrl,
            });
        }
    };

    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js')
            .then(async (registration) => {
                 try {
                     const env = (await import('variables/config')).default;
                     const reg = await navigator.serviceWorker.ready;
                     if (env?.apiUrl && reg.active) {
                         reg.active.postMessage({ type: 'SET_API_BASE_URL', url: env.apiUrl });
                     }
                 } catch {
                     // best-effort
                 }

                navigator.serviceWorker.ready
                    .then((readyRegistration) => {
                        postApiBaseUrlToSw(readyRegistration);
                    })
                    .catch(() => null);
            })
            .catch((err) => {
                console.warn('[SW] Registration failed:', err);
            });
    });
}


// Prune stale IndexedDB cache entries older than 7 days (non-blocking)
pruneStaleApiCache();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
);
